var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"skillDiagram",staticClass:"co-skill-diagram"},[_c('canvas',{staticClass:"co-skill-diagram__canvas",attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }